export const withinRange = (x: number, lowerBound: number, upperBound: number) => x >= lowerBound && x <= upperBound